// Lightweight timing helper for logging elapsed time through the race-load -> play flow.

let _perfBase = null;

export function perfStart(label) {
  _perfBase = performance.now();
  console.log(`[perf] START ${label}`);
}

export function perfLog(label) {
  const elapsed = _perfBase == null ? 0 : performance.now() - _perfBase;
  console.log(`[perf] +${elapsed.toFixed(0)}ms ${label}`);
}
